import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "user-header" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "A/C Client Code", -1)
const _hoisted_5 = { class: "col-sm-3" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Nominal Code", -1)
const _hoisted_8 = { class: "col-sm-3" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Works/Purchase order number required", -1)
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Landlord name required", -1)
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Landlord email required", -1)
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "form-group row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Payment in advance for Inv/CI", -1)
const _hoisted_20 = { class: "col-sm-4" }
const _hoisted_21 = { class: "form-group row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Payment in advance for CO/SOC", -1)
const _hoisted_23 = { class: "col-sm-4" }
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Invoice in advance", -1)
const _hoisted_26 = { class: "col-sm-4" }
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group row\"><div class=\"col-sm-9 offset-3\"><div class=\"row\"><div class=\"col-sm-2\">Email address</div><div class=\"col-md-2\">Inc Invoice</div><div class=\"col-md-2\">Inc Summary Doc</div><div class=\"col-md-2\">Copy in booked by</div><div class=\"col-md-2\">Issue to LL</div><div class=\"col-md-2\">Issue to TT</div></div></div></div>", 1)
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Inv & Check-In issue rules", -1)
const _hoisted_30 = { class: "col-sm-9" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-sm-2" }
const _hoisted_33 = { class: "col-md-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = { class: "form-group row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, " Check-Out and SOC issue rules", -1)
const _hoisted_40 = { class: "col-sm-9" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-sm-2" }
const _hoisted_43 = { class: "col-md-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "Defer to report settings", -1)
const _hoisted_45 = { class: "col-md-2" }
const _hoisted_46 = { class: "col-md-2" }
const _hoisted_47 = { class: "col-md-2" }
const _hoisted_48 = { class: "form-group row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, " Inv & Check-In issue to LL rules", -1)
const _hoisted_50 = { class: "col-sm-9" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-sm-2" }
const _hoisted_53 = { class: "col-md-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_55 = { class: "col-md-2" }
const _hoisted_56 = { class: "col-md-2" }
const _hoisted_57 = { class: "col-md-2" }
const _hoisted_58 = { class: "form-group row" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Check-Out and SOC issue to LL rules", -1)
const _hoisted_60 = { class: "col-sm-9" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-sm-2" }
const _hoisted_63 = { class: "col-md-2" }
const _hoisted_64 = { class: "col-md-2" }
const _hoisted_65 = { class: "col-md-2" }
const _hoisted_66 = { class: "col-md-2" }
const _hoisted_67 = { class: "col-md-2" }
const _hoisted_68 = { class: "form-group row" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Inv & Check-In issue to TT rules", -1)
const _hoisted_70 = { class: "col-sm-9" }
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col-sm-2" }
const _hoisted_73 = { class: "col-md-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_75 = { class: "col-md-2" }
const _hoisted_76 = { class: "col-md-2" }
const _hoisted_77 = { class: "col-md-2" }
const _hoisted_78 = { class: "form-group row" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Check-Out and SOC issue to TT rules:", -1)
const _hoisted_80 = { class: "col-sm-9" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-sm-2" }
const _hoisted_83 = { class: "col-md-2" }
const _hoisted_84 = { class: "col-md-2" }
const _hoisted_85 = { class: "col-md-2" }
const _hoisted_86 = { class: "col-md-2" }
const _hoisted_87 = { class: "col-md-2" }
const _hoisted_88 = { class: "form-group row" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Property Visit Issue Rules", -1)
const _hoisted_90 = { class: "col-sm-9" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = { class: "col-sm-2" }
const _hoisted_93 = { class: "col-md-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_95 = { class: "col-md-2" }
const _hoisted_96 = { class: "col-md-2" }
const _hoisted_97 = { class: "col-md-2" }
const _hoisted_98 = { class: "form-group row" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Other Report Issue Rules", -1)
const _hoisted_100 = { class: "col-sm-9" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "col-sm-2" }
const _hoisted_103 = { class: "col-md-2" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_105 = { class: "col-md-2" }
const _hoisted_106 = { class: "col-md-2" }
const _hoisted_107 = { class: "col-md-2" }
const _hoisted_108 = { class: "form-group row" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Inv & Check-In invoice issue rules", -1)
const _hoisted_110 = { class: "col-sm-9" }
const _hoisted_111 = { class: "row" }
const _hoisted_112 = { class: "col-sm-2" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_115 = { class: "col-md-2" }
const _hoisted_116 = { class: "col-md-2" }
const _hoisted_117 = { class: "col-md-2" }
const _hoisted_118 = { class: "form-group row" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Check-Out and SOC invoice issue rules", -1)
const _hoisted_120 = { class: "col-sm-9" }
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-sm-2" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "N/A", -1)
const _hoisted_125 = { class: "col-md-2" }
const _hoisted_126 = { class: "col-md-2" }
const _hoisted_127 = { class: "col-md-2" }
const _hoisted_128 = { class: "form-group row" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Misc notes", -1)
const _hoisted_130 = { class: "col-sm-6" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { Customer } from "@/models";
import { DxSwitch } from 'devextreme-vue/switch';


export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const store = useStore();
const customer = computed((): Customer => store.getters['customers/current']);
const editCustomer = async (customer: Customer) => await store.dispatch('customers/editCustomer', customer);
const setCustomerDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('customers/setCustomerDeep', payload);
}
const editCurrentCustomer = () => {
  editCustomer(customer.value);
};

//for invciissue
const invciissueemail = computed({
  get: () => { return customer.value.qcrules.invciissue.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.invciissue.email', data: val})}
});
const invciissueeincludeinvoice = computed({
  get: () => { return customer.value.qcrules.invciissue.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissue.includeinvoice', data: val})}
});
const invciissueccbookedby = computed({
  get: () => { return customer.value.qcrules.invciissue.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissue.ccbookedby', data: val})}
});
const invciissueissuetoll = computed({
  get: () => { return customer.value.qcrules.invciissue.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissue.issuetoll', data: val})}
});
const invciissueissuetott = computed({
  get: () => { return customer.value.qcrules.invciissue.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissue.issuetott', data: val})}
});

//for cosocissue
const cosocissueemail = computed({
  get: () => { return customer.value.qcrules.cosocissue.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.cosocissue.email', data: val})}
});
const cosocissueincludeinvoice = computed({
  get: () => { return customer.value.qcrules.cosocissue.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissue.includeinvoice', data: val})}
});
const cosocissueccbookedby = computed({
  get: () => { return customer.value.qcrules.cosocissue.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissue.ccbookedby', data: val})}
});
const cosocissueissuetoll = computed({
  get: () => { return customer.value.qcrules.cosocissue.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissue.issuetoll', data: val})}
});
const cosocissueissuetott = computed({
  get: () => { return customer.value.qcrules.cosocissue.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissue.issuetott', data: val})}
});


//for invciissuetoll
const invciissuetollemail = computed({
  get: () => { return customer.value.qcrules.invciissuetoll.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.invciissuetoll.email', data: val})}
});
const invciissuetollincludeinvoice = computed({
  get: () => { return customer.value.qcrules.invciissuetoll.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetoll.includeinvoice', data: val})}
});
const invciissuetollccbookedby = computed({
  get: () => { return customer.value.qcrules.invciissuetoll.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetoll.ccbookedby', data: val})}
});
const invciissuetollissuetoll = computed({
  get: () => { return customer.value.qcrules.invciissuetoll.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetoll.issuetoll', data: val})}
});
const invciissuetollissuetott = computed({
  get: () => { return customer.value.qcrules.invciissuetoll.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetoll.issuetott', data: val})}
});

//for cosocissuetoll
const cosocissuetollemail = computed({
  get: () => { return customer.value.qcrules.cosocissuetoll.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.cosocissuetoll.email', data: val})}
});
const cosocissuetollincludeinvoice = computed({
  get: () => { return customer.value.qcrules.cosocissuetoll.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetoll.includeinvoice', data: val})}
});

const cosocissuetollincludesummarydoc = computed({
  get: () => { return customer.value.qcrules.cosocissuetoll.includesummary},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetoll.includesummary', data: val})}
});

const cosocissuetollccbookedby = computed({
  get: () => { return customer.value.qcrules.cosocissuetoll.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetoll.ccbookedby', data: val})}
});
const cosocissuetollissuetoll = computed({
  get: () => { return customer.value.qcrules.cosocissuetoll.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetoll.issuetoll', data: val})}
});
const cosocissuetollissuetott = computed({
  get: () => { return customer.value.qcrules.cosocissuetoll.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetoll.issuetott', data: val})}
});


// for invciissuetott
const invciissuetottemail = computed({
  get: () => { return customer.value.qcrules.invciissuetott.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.invciissuetott.email', data: val})}
});
const invciissuetottincludeinvoice = computed({
  get: () => { return customer.value.qcrules.invciissuetott.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetott.includeinvoice', data: val})}
});

const invciissuetottccbookedby = computed({
  get: () => { return customer.value.qcrules.invciissuetott.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetott.ccbookedby', data: val})}
});
const invciissuetottissuetoll = computed({
  get: () => { return customer.value.qcrules.invciissuetott.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetott.issuetoll', data: val})}
});
const invciissuetottissuetott = computed({
  get: () => { return customer.value.qcrules.invciissuetott.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciissuetott.issuetott', data: val})}
});

// for cosocissuetott
const cosocissuetottemail = computed({
  get: () => { return customer.value.qcrules.cosocissuetott.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.cosocissuetott.email', data: val})}
});
const cosocissuetottincludeinvoice = computed({
  get: () => { return customer.value.qcrules.cosocissuetott.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetott.includeinvoice', data: val})}
});

const cosocissuetottincludesummarydoc = computed({
  get: () => { return customer.value.qcrules.cosocissuetott.includesummary},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetott.includesummary', data: val})}
});

const cosocissuetottccbookedby = computed({
  get: () => { return customer.value.qcrules.cosocissuetott.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetott.ccbookedby', data: val})}
});
const cosocissuetottissuetoll = computed({
  get: () => { return customer.value.qcrules.cosocissuetott.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetott.issuetoll', data: val})}
});
const cosocissuetottissuetott = computed({
  get: () => { return customer.value.qcrules.cosocissuetott.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocissuetott.issuetott', data: val})}
});

//for propvisitissue
const propvisitissueemail = computed({
  get: () => { return customer.value.qcrules.propvisitissue.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.propvisitissue.email', data: val})}
});
const propvisitissueincludeinvoice = computed({
  get: () => { return customer.value.qcrules.propvisitissue.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.propvisitissue.includeinvoice', data: val})}
});

const propvisitissueincludesummarydoc = computed({
  get: () => { return customer.value.qcrules.propvisitissue.includesummary},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.propvisitissue.includesummary', data: val})}
});

const propvisitissueccbookedby = computed({
  get: () => { return customer.value.qcrules.propvisitissue.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.propvisitissue.ccbookedby', data: val})}
});
const propvisitissuetoll = computed({
  get: () => { return customer.value.qcrules.propvisitissue.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.propvisitissue.issuetoll', data: val})}
});
const propvisitissuetott = computed({
  get: () => { return customer.value.qcrules.propvisitissue.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.propvisitissue.issuetott', data: val})}
});

//for otherreportissue
const otherreportissueemail = computed({
  get: () => { return customer.value.qcrules.otherreportissue.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.otherreportissue.email', data: val})}
});
const otherreportissueincludeinvoice = computed({
  get: () => { return customer.value.qcrules.otherreportissue.includeinvoice},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.otherreportissue.includeinvoice', data: val})}
});

const otherreportissueincludesummarydoc = computed({
  get: () => { return customer.value.qcrules.otherreportissue.includesummary},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.otherreportissue.includesummary', data: val})}
});

const otherreportissueccbookedby = computed({
  get: () => { return customer.value.qcrules.otherreportissue.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.otherreportissue.ccbookedby', data: val})}
});
const otherreportissuetoll = computed({
  get: () => { return customer.value.qcrules.otherreportissue.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.otherreportissue.issuetoll', data: val})}
});
const otherreportissuetott = computed({
  get: () => { return customer.value.qcrules.otherreportissue.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.otherreportissue.issuetott', data: val})}
});

//for invciinvoiceissue
const invciinvoiceissueemail = computed({
  get: () => { return customer.value.qcrules.invciinvoiceissue.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.invciinvoiceissue.email', data: val})}
});
const invciinvoiceissueccbookedby = computed({
  get: () => { return customer.value.qcrules.invciinvoiceissue.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciinvoiceissue.ccbookedby', data: val})}
});
const invciinvoiceissuetoll = computed({
  get: () => { return customer.value.qcrules.invciinvoiceissue.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciinvoiceissue.issuetoll', data: val})}
});
const invciinvoiceissuetott = computed({
  get: () => { return customer.value.qcrules.invciinvoiceissue.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.invciinvoiceissue.issuetott', data: val})}
});

//for cosocinvoiceissue
const cosocinvoiceissueemail = computed({
  get: () => { return customer.value.qcrules.cosocinvoiceissue.email},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.cosocinvoiceissue.email', data: val})}
});
const cosocinvoiceissueccbookedby = computed({
  get: () => { return customer.value.qcrules.cosocinvoiceissue.ccbookedby},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocinvoiceissue.ccbookedby', data: val})}
});
const cosocinvoiceissuetoll = computed({
  get: () => { return customer.value.qcrules.cosocinvoiceissue.issuetoll},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocinvoiceissue.issuetoll', data: val})}
});
const cosocinvoiceissuetott = computed({
  get: () => { return customer.value.qcrules.cosocinvoiceissue.issuetott},
  set: (val: boolean) => { setCustomerDeep({path: 'qcrules.cosocinvoiceissue.issuetott', data: val})}
});

//for Misc notes
const miscnotes = computed({
  get: () => { return customer.value.qcrules.misc},
  set: (val: string) => { setCustomerDeep({path: 'qcrules.misc', data: val})}
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customer.value.acClientCode) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.acClientCode,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customer.value.nominalCode) = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.nominalCode,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.workordernumberrequired,
                onValueChanged: _cache[4] || (_cache[4] = ($event: any) => (setCustomerDeep({ path: 'workordernumberrequired', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.accountsettings.llnamerequired,
                onValueChanged: _cache[5] || (_cache[5] = ($event: any) => (setCustomerDeep({ path: 'accountsettings.llnamerequired', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.accountsettings.llemailrequired,
                onValueChanged: _cache[6] || (_cache[6] = ($event: any) => (setCustomerDeep({ path: 'accountsettings.llemailrequired', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.accountsettings.paymentinadvinvci,
                onValueChanged: _cache[7] || (_cache[7] = ($event: any) => (setCustomerDeep({ path: 'accountsettings.paymentinadvinvci', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.accountsettings.paymentinadvcosoc,
                onValueChanged: _cache[8] || (_cache[8] = ($event: any) => (setCustomerDeep({ path: 'accountsettings.paymentinadvcosoc', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.accountsettings.invoiceinadvance,
                onValueChanged: _cache[9] || (_cache[9] = ($event: any) => (setCustomerDeep({ path: 'accountsettings.invoiceinadvance', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((invciissueemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      invciissueemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissueeincludeinvoice.value,
                    onValueChanged: _cache[11] || (_cache[11] = ($event: any) => (invciissueeincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissueccbookedby.value,
                    onValueChanged: _cache[12] || (_cache[12] = ($event: any) => (invciissueccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissueissuetoll.value,
                    onValueChanged: _cache[13] || (_cache[13] = ($event: any) => (invciissueissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissueissuetott.value,
                    onValueChanged: _cache[14] || (_cache[14] = ($event: any) => (invciissueissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((cosocissueemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      cosocissueemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissueincludeinvoice.value,
                    onValueChanged: _cache[16] || (_cache[16] = ($event: any) => (cosocissueincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissueccbookedby.value,
                    onValueChanged: _cache[17] || (_cache[17] = ($event: any) => (cosocissueccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissueissuetoll.value,
                    onValueChanged: _cache[18] || (_cache[18] = ($event: any) => (cosocissueissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissueissuetott.value,
                    onValueChanged: _cache[19] || (_cache[19] = ($event: any) => (cosocissueissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((invciissuetollemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      invciissuetollemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetollincludeinvoice.value,
                    onValueChanged: _cache[21] || (_cache[21] = ($event: any) => (invciissuetollincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetollccbookedby.value,
                    onValueChanged: _cache[22] || (_cache[22] = ($event: any) => (invciissuetollccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetollissuetoll.value,
                    onValueChanged: _cache[23] || (_cache[23] = ($event: any) => (invciissuetollissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetollissuetott.value,
                    onValueChanged: _cache[24] || (_cache[24] = ($event: any) => (invciissuetollissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((cosocissuetollemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      cosocissuetollemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetollincludeinvoice.value,
                    onValueChanged: _cache[26] || (_cache[26] = ($event: any) => (cosocissuetollincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetollincludesummarydoc.value,
                    onValueChanged: _cache[27] || (_cache[27] = ($event: any) => (cosocissuetollincludesummarydoc.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetollccbookedby.value,
                    onValueChanged: _cache[28] || (_cache[28] = ($event: any) => (cosocissuetollccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetollissuetoll.value,
                    onValueChanged: _cache[29] || (_cache[29] = ($event: any) => (cosocissuetollissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetollissuetott.value,
                    onValueChanged: _cache[30] || (_cache[30] = ($event: any) => (cosocissuetollissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((invciissuetottemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      invciissuetottemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetottincludeinvoice.value,
                    onValueChanged: _cache[32] || (_cache[32] = ($event: any) => (invciissuetottincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _hoisted_74,
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetottccbookedby.value,
                    onValueChanged: _cache[33] || (_cache[33] = ($event: any) => (invciissuetottccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetottissuetoll.value,
                    onValueChanged: _cache[34] || (_cache[34] = ($event: any) => (invciissuetottissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciissuetottissuetott.value,
                    onValueChanged: _cache[35] || (_cache[35] = ($event: any) => (invciissuetottissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _hoisted_79,
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((cosocissuetottemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      cosocissuetottemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetottincludeinvoice.value,
                    onValueChanged: _cache[37] || (_cache[37] = ($event: any) => (cosocissuetottincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetottincludesummarydoc.value,
                    onValueChanged: _cache[38] || (_cache[38] = ($event: any) => (cosocissuetottincludesummarydoc.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetottccbookedby.value,
                    onValueChanged: _cache[39] || (_cache[39] = ($event: any) => (cosocissuetottccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetottissuetoll.value,
                    onValueChanged: _cache[40] || (_cache[40] = ($event: any) => (cosocissuetottissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocissuetottissuetott.value,
                    onValueChanged: _cache[41] || (_cache[41] = ($event: any) => (cosocissuetottissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((propvisitissueemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      propvisitissueemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _createVNode(_unref(DxSwitch), {
                    value: propvisitissueincludeinvoice.value,
                    onValueChanged: _cache[43] || (_cache[43] = ($event: any) => (propvisitissueincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _hoisted_94,
                _createElementVNode("div", _hoisted_95, [
                  _createVNode(_unref(DxSwitch), {
                    value: propvisitissueccbookedby.value,
                    onValueChanged: _cache[44] || (_cache[44] = ($event: any) => (propvisitissueccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createVNode(_unref(DxSwitch), {
                    value: propvisitissuetoll.value,
                    onValueChanged: _cache[45] || (_cache[45] = ($event: any) => (propvisitissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_unref(DxSwitch), {
                    value: propvisitissuetott.value,
                    onValueChanged: _cache[46] || (_cache[46] = ($event: any) => (propvisitissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_98, [
            _hoisted_99,
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((otherreportissueemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      otherreportissueemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createVNode(_unref(DxSwitch), {
                    value: otherreportissueincludeinvoice.value,
                    onValueChanged: _cache[48] || (_cache[48] = ($event: any) => (otherreportissueincludeinvoice.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _hoisted_104,
                _createElementVNode("div", _hoisted_105, [
                  _createVNode(_unref(DxSwitch), {
                    value: otherreportissueccbookedby.value,
                    onValueChanged: _cache[49] || (_cache[49] = ($event: any) => (otherreportissueccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_unref(DxSwitch), {
                    value: otherreportissuetoll.value,
                    onValueChanged: _cache[50] || (_cache[50] = ($event: any) => (otherreportissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _createVNode(_unref(DxSwitch), {
                    value: otherreportissuetott.value,
                    onValueChanged: _cache[51] || (_cache[51] = ($event: any) => (otherreportissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("div", _hoisted_112, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((invciinvoiceissueemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      invciinvoiceissueemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _hoisted_113,
                _hoisted_114,
                _createElementVNode("div", _hoisted_115, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciinvoiceissueccbookedby.value,
                    onValueChanged: _cache[53] || (_cache[53] = ($event: any) => (invciinvoiceissueccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_116, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciinvoiceissuetoll.value,
                    onValueChanged: _cache[54] || (_cache[54] = ($event: any) => (invciinvoiceissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_117, [
                  _createVNode(_unref(DxSwitch), {
                    value: invciinvoiceissuetott.value,
                    onValueChanged: _cache[55] || (_cache[55] = ($event: any) => (invciinvoiceissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_118, [
            _hoisted_119,
            _createElementVNode("div", _hoisted_120, [
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("div", _hoisted_122, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((cosocinvoiceissueemail).value = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      cosocinvoiceissueemail.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _hoisted_123,
                _hoisted_124,
                _createElementVNode("div", _hoisted_125, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocinvoiceissueccbookedby.value,
                    onValueChanged: _cache[57] || (_cache[57] = ($event: any) => (cosocinvoiceissueccbookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocinvoiceissuetoll.value,
                    onValueChanged: _cache[58] || (_cache[58] = ($event: any) => (cosocinvoiceissuetoll.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_127, [
                  _createVNode(_unref(DxSwitch), {
                    value: cosocinvoiceissuetott.value,
                    onValueChanged: _cache[59] || (_cache[59] = ($event: any) => (cosocinvoiceissuetott.value = $event.value))
                  }, null, 8, ["value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_128, [
            _hoisted_129,
            _createElementVNode("div", _hoisted_130, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "5",
                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((miscnotes).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  miscnotes.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})